import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';

import style from '../../../../scss/headerDropdownMenu.scss';
import down from '../../icons/down';
import store from '../../store';
import {setHeaderDropdownState} from '../../slices/statusSlice';

@customElement('arc-header-dropdown-menu')
export class HeaderDropdownMenu extends connect(store)(LitElement) {
	static styles = [style];

	static properties = {
		title: {type: String},
		label: {type: String},
		dropdownId: {type: String},
		open: {type: Boolean},
		labelStyle: {type: String},
		menuAlignment: {type: String},
	};

	constructor() {
		super();
		this.title = '';
		this.label = 'Menu';
		this.labelStyle = 'label';
		this.dropdownId = 'default';
		this.open = false;
		this.menuAlignment = 'left';
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.open = (state.status.headerDropdownOpened === this.dropdownId);
	}

	toggleDropdown() {
		store.dispatch(setHeaderDropdownState({id: !this.open ? this.dropdownId : null}));
	}
	handleDropdown(state) {
		if (this.open !== state) {
			store.dispatch(setHeaderDropdownState({id: state ? this.dropdownId : null}));
		}
	}
	render() {
		return html`
			<button
				class="headerDropdown ${classMap({jsActive: this.open})}"
				aria-haspopup="true"
				aria-expanded="${this.open}"
				@click="${this.toggleDropdown}"
				@focus="${() => this.handleDropdown(true)}"
				@mouseover="${() => this.handleDropdown(true)}"
				@mouseout="${() => this.handleDropdown(false)}"
			>
				<div class="headerDropdownTitle">
					${when(
						this.labelStyle === 'icon',
						() => html`
							<div class="headerDropdownIcon">
								${this.label}
							</div>`,
						() => html`
							<div class="headerDropdownTitleText">
								<span class="headerLabel">${this.title}</span>
								<span class="headerName">${this.label}</span>
							</div>
						`
					)}
					${down}
				</div>
				<div class="headerDropdownContent ${this.menuAlignment}">
					<slot></slot>
				</div>
			</button>
		`;
	}
}
